import user_role_options from "utils/user_role_options";
import work_mode_options from "utils/work_mode_options";
import settlement_type_options from "utils/settlement_type_options";

export const sort = [
  { label: "ID", name: "id", style: { width: "20%" } },
  {
    label: "E-mail",
    name: "email",
    style: { width: "20%" },
  },
  {
    label: "Imię",
    name: "first_name",
    style: { width: "15%" },
  },
  {
    label: "Nazwisko",
    name: "last_name",
    style: { width: "15%" },
  },
  {
    label: "Rola",
    name: "role",
    style: { width: "10%" },
  },
  {
    label: "Typ rozliczenia",
    name: "is_pieceworker",
    style: { width: "8%" },
  },
  {
    label: "Tryb pracy",
    name: "work_mode",
    style: { width: "16%" },
  },
  {
    label: "Inw. ciężkie",
    name: "can_inventorize_heavy",
    style: { width: "9%" },
  },
];

export const filters = [
  {
    type: "input",
    name: "id",
    sort_id: "id",
    search_type: "matches",
  },
  {
    type: "input",
    name: "email",
    sort_id: "email",
    search_type: "matches",
  },
  {
    type: "input",
    name: "first_name",
    sort_id: "first_name",
    search_type: "matches",
  },
  {
    type: "input",
    name: "last_name",
    sort_id: "last_name",
    search_type: "matches",
  },
  {
    type: "select",
    name: "role",
    sort_id: "role",
    search_type: "eq",
    options: user_role_options,
  },
  {
    type: "select",
    name: "is_pieceworker",
    sort_id: "is_pieceworker",
    search_type: "eq",
    options: settlement_type_options,
  },
  {
    type: "select",
    name: "work_mode",
    sort_id: "work_mode",
    search_type: "eq",
    options: work_mode_options,
  },
];
